/**
 * The page is served on several domains at different prices, so the tab has to
 * agree with the page: a £ icon above a $1 headline looks broken.
 */

const ICON_SELECTORS = {
  svg: 'link[rel="icon"][type="image/svg+xml"]',
  ico: 'link[rel="icon"]:not([type])',
  apple: 'link[rel="apple-touch-icon"]',
} as const;

function setLink(selector: string, href: string) {
  const link = document.head.querySelector<HTMLLinkElement>(selector);
  // Only touch an href that actually changed: reassigning it makes some
  // browsers re-request the icon and flicker the tab.
  if (link && !link.getAttribute('href')?.endsWith(href)) {
    link.setAttribute('href', href);
  }
}

export function applyFavicon(currency: string) {
  const code = currency.toLowerCase();
  setLink(ICON_SELECTORS.svg, `/favicon-${code}.svg`);
  setLink(ICON_SELECTORS.ico, `/favicon-${code}.ico`);
  setLink(ICON_SELECTORS.apple, `/apple-touch-icon-${code}.png`);
}

export function applyTitle(amountLabel: string) {
  const title = `How many people paid ${amountLabel} to see how many people paid ${amountLabel}`;
  if (document.title !== title) document.title = title;

  const description = document.head.querySelector<HTMLMetaElement>('meta[name="description"]');
  description?.setAttribute(
    'content',
    `Pay ${amountLabel} to find out how many other people paid ${amountLabel} to find out.`,
  );
}
